import React from "react";
import { FaArrowRight } from "react-icons/fa";

const CTO = ({
    title = "Ready to Equip Your Team for ESG Excellence?",
    description = "Empower your leaders and employees with the knowledge and skills to drive sustainable, responsible, and impactful business practices.",
    buttonText = "Start Your ESG Journey",
    buttonLink = "/contact-us",
    enquiryTitle = "Have an Enquiry ?",
    enquiryDetails = "Call Us @ : +91 12345688 | +91 123245789",
    imageSrc = "/assets/images/esg-training/esg-ready-to-equip.png",
}) => {
    return (
        <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
            <div className="flex flex-col-reverse md:grid md:grid-cols-2">

                {/* Text Section */}
                <div className="flex flex-col justify-between w-full max-w-3xl py-0 mx-auto text-white md:py-10 sm:px-12">
                    <h2 className="text-left !leading-snug text-3xl sm:text-4xl font-[600] text-[#000000] my-4 sm:mt-10">
                        {title.split("<br />").map((line, index) => (
                            <React.Fragment key={index}>
                                {index > 0 && <br />}
                                {line}
                            </React.Fragment>
                        ))}
                    </h2>

                    <p className="mb-4 text-[#1C486B] text-xl font-[600] leading-8">
                        {description}
                    </p>

                    <div>
                        <button
                            className="bg-[#1C486B] rounded-[8px] py-3 px-4 font-[600] flex flex-row items-center gap-2 text-white"
                            onClick={() => (window.location.href = buttonLink)}
                        >
                            {buttonText} <FaArrowRight />
                        </button>
                    </div>
                </div>

                {/* Image Section */}
                <div className="flex justify-center my-8 rounded-[12px] overflow-hidden">
                    <img
                        src={imageSrc}
                        alt="ESG Training"
                        className="w-[60%] object-contain"
                    />
                </div>
            </div>
        </section>
    );
};

export default CTO;
